var _g, _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCheckMarkRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 118,
    viewBox: "0 0 91 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2534_2583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7013 80.2616C64.5336 80.0934 79.6654 64.5264 79.4991 45.4915C79.3327 26.4567 63.9313 11.1622 45.0989 11.3304C26.2666 11.4985 11.1348 27.0655 11.3012 46.1004C11.4675 65.1352 26.869 80.4297 45.7013 80.2616Z",
    fill: "#FF6633"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2534_2583",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 45.5C91 70.629 70.629 91 45.5 91C20.371 91 0 70.629 0 45.5C0 20.371 20.371 0 45.5 0C70.629 0 91 20.371 91 45.5ZM6.83081 45.5C6.83081 66.8564 24.1436 84.1692 45.5 84.1692C66.8564 84.1692 84.1692 66.8564 84.1692 45.5C84.1692 24.1436 66.8564 6.83081 45.5 6.83081C24.1436 6.83081 6.83081 24.1436 6.83081 45.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 45.5C91 70.629 70.629 91 45.5 91C20.371 91 0 70.629 0 45.5C0 20.371 20.371 0 45.5 0C70.629 0 91 20.371 91 45.5ZM6.83081 45.5C6.83081 66.8564 24.1436 84.1692 45.5 84.1692C66.8564 84.1692 84.1692 66.8564 84.1692 45.5C84.1692 24.1436 66.8564 6.83081 45.5 6.83081C24.1436 6.83081 6.83081 24.1436 6.83081 45.5Z",
    stroke: "white",
    strokeWidth: 14,
    mask: "url(#path-2-inside-1_2534_2583)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6269 29.7806C66.2172 30.9975 66.4619 33.2015 65.1734 34.7034L41.1539 62.7033C40.4892 63.4782 39.506 63.9484 38.4513 63.996C37.3966 64.0436 36.3704 63.664 35.6305 62.9525L25.0619 52.7895C23.6278 51.4105 23.6489 49.1945 25.1091 47.84C26.5694 46.4856 28.9157 46.5055 30.3498 47.8846L38.0089 55.2497L59.4146 30.2968C60.703 28.7949 63.0366 28.5638 64.6269 29.7806Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2534_2583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.2006,
    height: 68.9338,
    fill: "white",
    transform: "matrix(0.99996 -0.00892696 0.00873805 0.999962 11 11.6348)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheckMarkRound);
export default __webpack_public_path__ + "static/media/orange-check-mark-round.ac426d8d75db50d6ecf3899aecaa0794.svg";
export { ForwardRef as ReactComponent };